import Section from '../ui/Section';
import SectionTitle from '../ui/SectionTitle';
import { Stagger, StaggerItem } from '../ui/Reveal';
import { whyChooseUs } from '../../data/industries';

const partnerBrands = ['HP', 'Dell', 'Lenovo', 'Supermicro', 'Cisco', 'Arista', 'Juniper'];

const WhyChooseSection = () => {
  const [feature, ...rest] = whyChooseUs;
  const FeatureIcon = feature.icon;

  return (
    <Section className="relative overflow-hidden bg-slate-950">
      <div className="absolute inset-0 -z-0 bg-grid-slate opacity-50" aria-hidden="true" />
      <div
        className="absolute -left-24 top-16 -z-0 h-80 w-80 rounded-full bg-brand-500/10 blur-[120px]"
        aria-hidden="true"
      />
      <div
        className="absolute -right-10 bottom-0 -z-0 h-80 w-80 rounded-full bg-accent-500/10 blur-[120px]"
        aria-hidden="true"
      />

      <div className="relative">
        <SectionTitle
          tone="dark"
          eyebrow="Why NEAT"
          title="Built different, on purpose"
          subtitle="The advantages that set us apart in the enterprise technology landscape"
        />

        <Stagger className="grid gap-4 md:grid-cols-2 lg:grid-cols-4 lg:auto-rows-fr">
          {/* Feature tile */}
          <StaggerItem className="md:col-span-2 lg:row-span-2">
            <div className="group gradient-ring relative flex h-full flex-col overflow-hidden rounded-3xl border border-white/10 bg-white/[0.04] p-8 backdrop-blur transition-colors duration-300 hover:bg-white/[0.07]">
              <div
                className="absolute -right-12 -top-12 h-48 w-48 rounded-full bg-brand-500/20 blur-3xl transition-transform duration-700 group-hover:scale-125"
                aria-hidden="true"
              />
              <span className="relative flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-brand-500 to-accent-500 text-white shadow-glow-brand">
                <FeatureIcon className="h-8 w-8" aria-hidden="true" />
              </span>
              <h3 className="relative mt-6 text-2xl font-bold text-white md:text-3xl">
                {feature.title}
              </h3>
              <p className="relative mt-3 max-w-md leading-relaxed text-slate-300">
                {feature.description}
              </p>
              <div className="relative mt-auto flex flex-wrap gap-2 pt-8">
                {partnerBrands.map((brand) => (
                  <span
                    key={brand}
                    className="rounded-full border border-white/10 bg-white/5 px-3 py-1 text-xs font-medium text-slate-300"
                  >
                    {brand}
                  </span>
                ))}
              </div>
            </div>
          </StaggerItem>

          {/* Supporting tiles */}
          {rest.map((item) => {
            const Icon = item.icon;
            return (
              <StaggerItem key={item.id} className="lg:col-span-1">
                <div className="group gradient-ring relative h-full rounded-3xl border border-white/10 bg-white/[0.04] p-6 backdrop-blur transition-colors duration-300 hover:bg-white/[0.07]">
                  <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-brand-500/90 to-accent-500/90 text-white">
                    <Icon className="h-6 w-6" aria-hidden="true" />
                  </span>
                  <h3 className="mt-4 text-lg font-bold text-white">{item.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-400">{item.description}</p>
                </div>
              </StaggerItem>
            );
          })}
        </Stagger>
      </div>
    </Section>
  );
};

export default WhyChooseSection;
